import styles from './blog_post.module.sass'

import classNames from 'classnames'

import Image from '../basic/image'
import Button from '../basic/button'
import BlogCarousel from './blog_carousel'

function BlogPost(props) {
	let fields = props.fields

	return <div className={styles.blog_post}>
		<h1>{fields.title}</h1>
		<div className={styles.header_wrapper}>
			<div className={classNames(styles.author_wrapper, styles[`count_${fields.authors?.length}`])}>
				<div className={styles.author_image_wrapper}>
					{fields.authors?.map((author, i) => {
						return <div>
							{author.image &&
								<Image {...author.image} className={styles.author_image} />
							}
						</div>
					})}
				</div>
				<div className={styles.author_meta_wrapper}>
					<div className={styles.date_type}>{fields.date} | <span className={styles.post_type}>Blog</span></div>
					{fields.authors?.map((author, i) => {
						return <div>
							{author.name && <div className={styles.author_name}>{author.name}</div>}
							{author.title && <div className={styles.author_title}>{author.title}</div>}
							{author.company && <div className={styles.author_company}>{author.company}</div>}
						</div>
					})}
				</div>
			</div>
			<div className={styles.blog_wrapper}>
				<p>Discover the NeXT generation authored by Personalis staff. Our blog posts provide insights into our company — and the people who are on the front lines in the fight against cancer.</p>
				<Button fields={{button: {url: '/resources/blog', title: 'More Articles'}}} button_style='style_2'></Button>
			</div>
		</div>
		<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
		
		<div className={styles.more_articles}>
		<div className={styles.more_articles_header}>
				<h2>More Blog Articles</h2>
				<Button fields={{button: {url: '/resources/blog', title: 'Blog Home'}}} button_style='style_4' className={styles.blog_home}></Button>
			</div>
			<hr />
			<BlogCarousel fields={{items: fields.more_articles}}/>
		</div>
	</div>
}

export default BlogPost